module.exports = __webpack_public_path__ + "assets/29252397225b77f813e43397547baeb8.png";